import React, { memo, useEffect, useMemo, useState } from "react";
import { Collapse, Icon } from "antd";
import styles from "../JobStyle.module.css";
import FrequencyHeader from "./FrequencyHeader";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom"
// import { getTaskFrequency } from "../../../../actions/v2/JobActions";
// import { Strings } from "../../../../dataProvider/localize";
// import { notification } from "antd";
import Frequency from "./Frequency";
import { LinearProgress } from "@mui/material";
import { getStorage } from "../../../../utils/common";
import { ACCESS_CONTROL } from "../../../../dataProvider/constant";

const { Panel } = Collapse;

const FrequencyList = ({ selectedTask, jobId, selectedJobDetails, refreshHistory, fetchFrequencies, frequencies, loading, setSelectedTask }) => {

  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    if (location.goToTab === "ViewFrequency") {
      setActiveKey(location.frequencyNumber)
    }
  }, [location])

  const togglePanelKey = (key) => {
    if (activeKey !== key) {
      setActiveKey(key)
    } else {
      setActiveKey(null)
    }
  }

  const getNextFrequency = (frequency) => {
    const index = frequencies.findIndex(x => x.quote_task_id === frequency.quote_task_id);
    if (index === -1 || index + 1 === frequencies.length) {
      return null;
    } else {
      return frequencies[index + 1];
    }
  }

  const permissions = useMemo(() => {
    try {
      const calPermissions = JSON.parse(getStorage(ACCESS_CONTROL))["calendar"]
      const accessControl = calPermissions && calPermissions.permissions ? calPermissions.permissions : [];

      const modulePermissions = {
        viewJobTaskCost: accessControl.findIndex(access => access.control_name === "sf_view_task_job_value_view_task_job_value"),
        manageIssuePOButton: accessControl.findIndex(access => access.control_name === "sf_manage_issue_pobutton_manage_issue_pobutton"),
        manageResourcingPanel: accessControl.findIndex(access => access.control_name === "sf_manage_resourcing_panel_manage_resourcing_panel"),
        manageAdjustmentPanel: accessControl.findIndex(access => access.control_name === "sf_manage_new_adjustment_panel_manage_new_adjustment_pa"),
        manageFrequencyStatus: accessControl.findIndex(access => access.control_name === "sf_manage_task_frequency_status_manage_task_frequency_s")
      }
      return modulePermissions;
    } catch (e) {
      return {}
    }
  }, []);

  const canSeeValues = useMemo(() => {
    if (!permissions) return false;
    return permissions.viewJobTaskCost !== -1;
  }, [permissions])

  const canManageIssuePO = useMemo(() => {
    if (!permissions) return false;
    return permissions.manageIssuePOButton !== -1;
  })

  const canManageResourcing = useMemo(() => {
    if (!permissions) return false;
    return permissions.manageResourcingPanel !== -1;
  })

  const canManageAdjustment = useMemo(() => {
    if (!permissions) return false;
    return permissions.manageAdjustmentPanel !== -1;
  })

  const canManageFrequencyStatus = useMemo(() => {
    if (!permissions) return false;
    return permissions.manageFrequencyStatus !== -1;
  })

  return (
    <div>
      <div className={`${styles.JobTasksListContainer}`}>
        <div style={{ height: "4px" }}>
          {loading ? (
            <LinearProgress />
          ) : null}
        </div>
        <Collapse
          bordered={false}
          className={`${styles.Collapse} `}
          accordion
          onChange={(e) => togglePanelKey(e)}
          destroyInactivePanel={true}
          activeKey={activeKey}
          expandIcon={({ isActive, showIcon = true }) => (
            <Icon
              type={isActive ? "minus" : "plus"}
              className={`${styles.PrimaryText} ${!showIcon ? styles.transparentIcon : ''}`}
            />
          )}
        >
          {frequencies.map(frequency =>
            <Panel
              key={frequency.frequency_number}
              className={`${styles.PanelV2} ${styles.FrequencyPanelItem} collapse-panel-no-y-padding`}
              header={<FrequencyHeader
                frequency={frequency}
                selectedTask={selectedTask}
                canSeeValues={canSeeValues}
                canManageFrequencyStatus={canManageFrequencyStatus}
                refreshHistory={refreshHistory}
                getNextFrequency={getNextFrequency}
                setSelectedTask={setSelectedTask}
                fetchFrequencies={fetchFrequencies}
                jobId={jobId}
                selectedJobDetails={selectedJobDetails}
                onActive={() => togglePanelKey(frequency.frequency_number)}
              />}
              // disabled={task.task_type === "JOB_TASK"}
              isActive={activeKey === frequency.frequency_number}
              showIcon={true}
              openAnimation={Collapse.defaultProps.openAnimation}
            >
              <Frequency
                frequency={frequency}
                key={frequency.frequency_number}
                jobId={jobId}
                canManageIssuePO={canManageIssuePO}
                canManageAdjustment={canManageAdjustment}
                canManageResourcing={canManageResourcing}
                setSelectedTask={setSelectedTask}
                getNextFrequency={getNextFrequency}
                refreshHistory={refreshHistory}
                selectedTask={selectedTask}
                fetchFrequencies={fetchFrequencies}
                selectedJobDetails={selectedJobDetails}
              />
            </Panel>
          )}
        </Collapse>
      </div>
    </div >
  )
}

export default memo(FrequencyList);